import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import EmailSubscriptionOptOut from '../components/email-subscription-opt-out-view';
import {
  meUserName,
  meIsConflicted,
} from 'modules/me-module';
import environment from 'lib/environment';

const marketingOptOutUrl = environment.get().marketing_opt_out_url;

export class EmailSubscriptionOptOutContainer extends React.Component {
  optOutUrl = () => `${marketingOptOutUrl}?Email=${this.props.userName}`;

  render() {
    return (
      <EmailSubscriptionOptOut
        marketingOptOutUrl={this.optOutUrl()}
        isViewOnly={this.props.isViewOnly}
      />
    );
  }
}

EmailSubscriptionOptOutContainer.propTypes = {
  userName: PropTypes.string.isRequired,
  isViewOnly: PropTypes.bool,
};

export const mapStateToProps = (state) => ({
  userName: meUserName(state) || '',
  isViewOnly: meIsConflicted(state),
});

export default connect(mapStateToProps)(EmailSubscriptionOptOutContainer);
